import { setShowSupplierItemModal } from '../State/showSupplierItemModal';
import fetchSupplier from '../Services/fetchSupplier';

export default () => async (dispatch) => {
  dispatch(setShowSupplierItemModal(false));
  dispatch(fetchSupplier());
}
